import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import TermsModal from './TermsModal';

const Footer = () => {
    const location = useLocation();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [modalType, setModalType] = useState('');
    
    // 푸터를 숨길 페이지들
    const hideFooterPaths = ['/', '/login'];
    
    // 현재 경로가 푸터를 숨길 페이지인지 확인
    if (hideFooterPaths.includes(location.pathname)) {
        return null;
    }

    const openTermsModal = (type) => {
        setModalType(type);
        setIsModalOpen(true);
    };

    const closeTermsModal = () => {
        setIsModalOpen(false);
        setModalType('');
    };

    return (
        <>
            <footer className="footer">
                <div className="footer-content">
                    <div className="footer-links">
                        <button 
                            className="footer-link" 
                            onClick={() => openTermsModal('service')}
                        >
                            이용약관
                        </button>
                        <span className="footer-separator">|</span>
                        <button 
                            className="footer-link" 
                            onClick={() => openTermsModal('privacy')}
                        >
                            개인정보 수집 및 이용
                        </button>
                        <span className="footer-separator">|</span>
                        <button 
                            className="footer-link" 
                            onClick={() => openTermsModal('refund')}
                        >
                            환불 및 반품 정책
                        </button>
                    </div>
                </div>
            </footer>

            {/* 약관 모달 */}
            <TermsModal 
                isOpen={isModalOpen}
                onClose={closeTermsModal}
                type={modalType}
                buttonText="확인"
            />
        </>
    );
};

export default Footer; 